// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const auditLogListQuerySchema = paginationQuerySchema.and(
  z.object({
    objectType: z.array(z.string()).optional(),
    objectId: z.array(z.number()).optional(),
    action: z.array(z.string()).optional(),
  })
);
